import { removeViewsFromGrid } from '@src/components/AppLayout/utils/removeViewsFromGrid';
import type { SerializedDockview } from 'dockview';

interface RemoveMarketPanelParams {
  currentPanelId: string;
  deletedPanelId: string;
  marketPanelIds: readonly string[];
  sourceDockViewLayout: SerializedDockview;
}

export function getLayoutWithoutMarketPanel({
  currentPanelId,
  deletedPanelId,
  marketPanelIds,
  sourceDockViewLayout,
}: RemoveMarketPanelParams): { dockViewLayout: SerializedDockview; nextPanelId: string } | undefined {
  if (sourceDockViewLayout.panels[deletedPanelId] == null) {
    return undefined;
  }

  const dockViewLayout = structuredClone(sourceDockViewLayout);
  delete dockViewLayout.panels[deletedPanelId];

  const root = removeViewsFromGrid([deletedPanelId], dockViewLayout.grid.root);
  if (root == null) {
    return undefined;
  }

  dockViewLayout.grid.root = root;
  const nextPanelId =
    currentPanelId === deletedPanelId || dockViewLayout.panels[currentPanelId] == null
      ? getNextMarketPanelId({ deletedPanelId, dockViewLayout, marketPanelIds })
      : currentPanelId;

  if (nextPanelId == null) {
    return undefined;
  }

  return {
    dockViewLayout,
    nextPanelId,
  };
}

function getNextMarketPanelId({
  deletedPanelId,
  dockViewLayout,
  marketPanelIds,
}: {
  deletedPanelId: string;
  dockViewLayout: SerializedDockview;
  marketPanelIds: readonly string[];
}) {
  const deletedMarketIndex = marketPanelIds.indexOf(deletedPanelId);
  const remainingMarketPanelIds = marketPanelIds.filter(panelId => {
    return panelId !== deletedPanelId && dockViewLayout.panels[panelId] != null;
  });
  if (remainingMarketPanelIds.length === 0) {
    return undefined;
  }

  const nextMarketIndex =
    deletedMarketIndex === -1 ? 0 : Math.min(deletedMarketIndex, remainingMarketPanelIds.length - 1);
  return remainingMarketPanelIds[nextMarketIndex];
}
